import produce from "immer";
import React, { FC, useState } from "react";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import { startEditElement } from "../../../actions/elementListAction";
import { Element } from "../../../models/elementModel";
import { CheckboxOrRadio } from "../../../utils/constants";
import "./elementProprtiesPanal.scss";
import {
  getAllElements,
  getElementByType,
} from "../../../selectors/elementListSelector";
import { toast } from "react-toastify";
import { cssStyle } from "../../../models/cssStyleModel";
import { uuid } from "uuidv4";
import chamalCasingCss from "../common/commonPropertyUtil/chamalCasingCss";

export interface RadioElementPropertiesProps {
  element: Element;
}
const RadioProperties: FC<RadioElementPropertiesProps> = ({ element }) => {
  const dispatch = useDispatch();
  const radioBtnList = useSelector(getElementByType(element.type));


  const addNewCssStyle = () => {
    let newCssStyle: cssStyle = {
      id: uuid(),
      style: "",
      retrivedStyle: "",
      value: "",
    };
    const newElement = produce(element, (draft) => {
      draft.properties.lblCssStyles.push(newCssStyle);
    });
    dispatch(startEditElement(newElement));
  };

  const removeCssStyle = (index: number) => {
    const newElement = produce(element, (draft) => {
      draft.properties.lblCssStyles.splice(index, 1);
    });
    dispatch(startEditElement(newElement));
  };

  const errorValidation = () => {
    toast.error("Cannot add minus values", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };
  const radiobtnDefaultCheck = (isChecked: boolean) => {
    if (isChecked) {
      const otherRadioBtns = radioBtnList.filter((radio) => {
        return (
          radio.id !== element.id &&
          radio.properties.groupName === element.properties.groupName &&
          radio.properties.checked === true
        );
      });
      if (otherRadioBtns.length > 0) {
        for (let i = 0; otherRadioBtns.length > i; i++) {
          const otherCheckedRadioBtnElement = produce(
            otherRadioBtns[i],
            (draft) => {
              draft.properties.checked = false;
            }
          );
          dispatch(startEditElement(otherCheckedRadioBtnElement));
          console.log(otherCheckedRadioBtnElement);
        }
      }
    }
  };
  return (
    <div className="container mt-3">
      <div className="form-group row">
        <label
          htmlFor="elementName"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Name
        </label>
        <div className="col-sm-8">
          <input
            value={`${element.name}`}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.name = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="elementName"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="field-showLabel"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Hide Label
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.showLabel}
            onChange={() => {
              const newElement = produce(element, (draft) => {
                draft.properties.showLabel = !draft.properties.showLabel;
              });
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch items-align-left"
            id="material-switch-margine"
          />
        </div>
      </div>
      {element.properties.showLabel && (
        <div className="form-group row">
          <label
            htmlFor="heading-txt"
            className="col-sm-4 col-form-label font-size-12 align-text-left"
          >
            Label Text
          </label>
          <div className="col-sm-8">
            <input
              value={element.properties.labelRadio}
              className="form-control theam-textbox items-align-left"
              onChange={(e) => {
                const newElement = produce(element, (draft) => {
                  draft.properties.labelRadio = e.target.value;
                });
                dispatch(startEditElement(newElement));
              }}
              type="text"
              id="heading-txt"
            />
          </div>
        </div>
      )}
      <div className="form-group row">
        <label
          htmlFor="field-disabled"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Disable
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.disabled}
            onChange={() => {
              const newElement = produce(element, (draft) => {
                draft.properties.disabled = !draft.properties.disabled;
              });
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch items-align-left"
            id="material-switch-margine"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="radioSize"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Size
        </label>
        <div className="col-sm-8">
          <input
            value={element.properties.radioSize}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.radioSize = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
            type="number"
            id="radioSize"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="group-Name"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Group Name
        </label>
        <div className="col-sm-8">
          <input
            value={element.properties.groupName}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.groupName = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="group-Name"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="required-field"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Required
        </label>
        <div className="col-sm-2 mt-2">
          <Switch
            checked={element.properties.required}
            onChange={() => {
              const newElement = produce(element, (draft) => {
                draft.properties.required = !draft.properties.required;
              });
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="required-field"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="default-field"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Default
        </label>
        <div className="col-sm-2 mt-2">
          <Switch
            checked={element.properties.checked}
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.checked = !draft.properties.checked;
              });
              dispatch(startEditElement(newElement));
              radiobtnDefaultCheck(e);
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="required-field"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="btn-outline"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Display
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.display}
            onChange={() => {
              const newElement = produce(element, (draft) => {
                draft.properties.display = !draft.properties.display;
              });
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="btn-outline"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="tooltip"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Tooltip
        </label>
        <div className="col-sm-8">
          <textarea
            className="form-control theam-textbox font-size-12 items-align-left"
            name="tooltip"
            id="tooltip"
            placeholder="Enter tooltip"
            cols={30}
            rows={2}
            value={element.properties.tooltip}
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.tooltip = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
          ></textarea>
        </div>
      </div>
      <br />

      {element.properties.showLabel && (
        <>
          <div className="form-group row">
            <label htmlFor="" className="col-sm-12 col-form-label">
              Label Properties
            </label>
          </div>
          <div className="form-group row align-items-center">
            <label
              htmlFor="section-size"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Align Right
            </label>
            <div className="col-sm-2 mt-1">
              <Switch
                checked={element.properties.labalAlign}
                onChange={() => {
                  const newElement = produce(element, (draft) => {
                    draft.properties.labalAlign = !draft.properties.labalAlign;
                    // draft.properties.marginRight = '30';
                  });
                  dispatch(startEditElement(newElement));
                }}
                onColor="#86d3ff"
                onHandleColor="#2693e6"
                handleDiameter={15}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={10}
                width={24}
                className="react-switch items-align-left"
                id="material-switch-margine"
              />
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="marginTop"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Margine Top
            </label>
            <div className="col-sm-8">
              <input
                value={element.properties.marginTop}
                min="0"
                className="form-control theam-textbox items-align-left"
                onChange={(e) => {
                  if (parseInt(e.target.value) >= 0 || e.target.value == "") {
                    const newElement = produce(element, (draft) => {
                      draft.properties.marginTop = e.target.value;
                    });
                    dispatch(startEditElement(newElement));
                  } else {
                    errorValidation();
                  }
                }}
                type="number"
                id="marginTop"
              />
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="marginBottom"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Margine Bottom
            </label>
            <div className="col-sm-8">
              <input
                value={element.properties.marginBottom}
                min="0"
                className="form-control theam-textbox items-align-left"
                onChange={(e) => {
                  if (parseInt(e.target.value) >= 0 || e.target.value == "") {
                    const newElement = produce(element, (draft) => {
                      draft.properties.marginBottom = e.target.value;
                    });
                    dispatch(startEditElement(newElement));
                  } else {
                    errorValidation();
                  }
                }}
                type="number"
                id="marginBottom"
              />
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="marginRight"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Margine Right
            </label>
            <div className="col-sm-8">
              <input
                value={element.properties.marginRight}
                className="form-control theam-textbox items-align-left"
                onChange={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.properties.marginRight = e.target.value;
                  });
                  dispatch(startEditElement(newElement));
                }}
                type="number"
                id="marginRight"
              />
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="marginLeft"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Margine Left
            </label>
            <div className="col-sm-8">
              <input
                value={element.properties.marginLeft}
                className="form-control theam-textbox items-align-left"
                onChange={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.properties.marginLeft = e.target.value;
                  });
                  dispatch(startEditElement(newElement));
                }}
                type="number"
                id="marginLeft"
              />
            </div>
          </div>
          <h6>Label Advance Style Properties</h6>
          <div className="form-group col-12 m-2 p-2">
            <button
              type="button"
              className="btn btn-dark btn-sm font-size-12"
              onClick={addNewCssStyle}
            >
              <i className="fa fa-plus"></i>
            </button>
          </div>

          {element.properties.lblCssStyles?.map(
            (_style: cssStyle, i: number) => {
              return (
                <div key={i}>
                  <div className="form-group row">
                    <div className="col-sm-10"></div>
                    <div className="col-sm-2">
                      <button
                        type="button"
                        className="btn btn-dark btn-sm font-size-12"
                        onClick={(e) => removeCssStyle(i)}
                      >
                        <i className="fa fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-5 noPadding">
                      <input
                        type="text"
                        className="form-control theam-textbox"
                        id={`style${i}`}
                        value={_style.style}
                        placeholder="Css Property"
                        onChange={(e) => {
                          const newElement = produce(element, (draft) => {
                            draft.properties.lblCssStyles[i].style =
                              e.target.value;
                            draft.properties.lblCssStyles[i].retrivedStyle =
                              chamalCasingCss(e.target.value);
                          });
                          dispatch(startEditElement(newElement));
                        }}
                      />
                    </div>
                    <div className="col-sm-1 noPadding">:</div>
                    <div className="col-sm-6 noPadding">
                      <input
                        type="text"
                        className="form-control theam-textbox"
                        id={`value${i}`}
                        value={_style.value}
                        placeholder="Enter Value"
                        onChange={(e) => {
                          const newElement = produce(element, (draft) => {
                            draft.properties.lblCssStyles[i].value =
                              e.target.value;
                          });
                          dispatch(startEditElement(newElement));
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            }
          )}
        </>
      )}
    </div>
  );
};

export default RadioProperties;
